import angular from "angular";

angular
    .module('app')
    .component('organizationClientsControl', {
        template: require('./organizatioin-clients-control.html'),
        controller: ['$http', '$uibModal', 'notifier', controller],
        bindings: {
            organization: '<',
            fields: '<',
            selectedFields: '<',
        }
    });

function controller($http, $uibModal, notifier) {

    const $ctrl = this;

    $ctrl.clients = [];

    $ctrl.total = null;

    $ctrl.page = 1;

    $ctrl.perPage = 15;

    $ctrl.search = '';

    $ctrl.$onInit = () => {
        $ctrl.getList();
        $ctrl.setTableFields();
    };

    $ctrl.getList = () => {
        $http
            .get(`/control-panel/organizations/${$ctrl.organization.id}/clients/get-list`, {
                params: {
                    page: $ctrl.page,
                    search: $ctrl.search,
                }
            })
            .then(res => {
                $ctrl.total = res.data.total;
                $ctrl.clients = res.data.data;

                $ctrl.clients.forEach(client => {
                    client.fieldValues = {};

                    $ctrl.selectedFields.forEach(field => {
                        if (field.pivot.edit_on_directory) {
                            const fieldValue = client.field_values.find(v => v.field_id === field.id);

                            if (fieldValue) {
                                client.fieldValues[field.id] = fieldValue.value;
                            }

                            if (field.pivot.default_value && !client.fieldValues[field.id]) {
                                client.fieldValues[field.id] = field.pivot.default_value;
                            }
                        }
                    });
                });
            });
    };

    $ctrl.filter = () => {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openFieldsControlForm = () => {
        $uibModal.open({
            component: 'clientsFieldsControl',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                fields() {
                    return $ctrl.fields;
                },
                selectedFields() {
                    return $ctrl.selectedFields;
                }
            },
            size: 'lg',
        }).result.then(fields => {
            $ctrl.selectedFields = fields.map(field => {
                let fieldObj = angular.copy($ctrl.fields.find(v => v.id === field.field_id));

                fieldObj.pivot = {
                    custom_title: field.custom_title,
                    edit_on_directory: field.edit_on_directory,
                    edit_on_booking: field.edit_on_booking,
                    required_on_booking: field.required_on_booking,
                    default_value: field.default_value,
                };

                return fieldObj
            });

            $ctrl.setTableFields();
            $ctrl.getList();
        });
    };

    $ctrl.setTableFields = () => {
        $ctrl.tableFields = $ctrl.selectedFields.filter(v => !! v.pivot.edit_on_directory);
    };

    $ctrl.openForm = (client) => {
        $uibModal.open({
            component: 'organizationClientForm',
            resolve: {
                organization() {
                    return $ctrl.organization;
                },
                fields() {
                    return $ctrl.selectedFields.filter(v => v.pivot.edit_on_directory);
                },
                client() {
                    return client;
                }
            },
        }).result.then(res => {
            $ctrl.getList();
        });
    };

    $ctrl.delClient = (client, ind) => {
        if (confirm('Вы действительно хотите удалить клиента?')) {
            $http
                .post(`/control-panel/organizations/${$ctrl.organization.id}/clients/${client.id}`, {_method: 'DELETE'})
                .then(
                    res => {
                        notifier.successNotify('Успешно удален');
                        $ctrl.clients.splice(ind, 1);
                    },
                    err => {
                        notifier.errorResponseNotify(err);
                    }
                );
        }
    };
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/organization-clients-control/organization-clients-control.js